<span  (click)="changeRoute(params)" 
[ngStyle]="params.data.noOfRecords > 0 ? {'cursor':'pointer'}:{'cursor':'not-allowed'}"
>{{ dataToShow }}</span>
